export default __webpack_public_path__ + "static/media/send.013d09eb.svg";